import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled.p`
    width: 50%;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
`;

const Error = (props) => {
    const { message } = props;

    return (
        <Wrapper>{ message }</Wrapper>
    );
};

Error.defaultProps = {
    message: '',
};

Error.propTypes = {
    message: PropTypes.string,
};

export default Error;



// WEBPACK FOOTER //
// ./src/pages/products/productAvailibity/Error.js